const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  brandWrapper: {
    maxWidth: "990px",
    width: "70%",
    margin: "0 auto 50px",
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    "@media (max-width: 767px)": {
      padding: "10px",
    },
    "@media (min-width: 768px) and (max-width: 768px)": {
      padding: "0 70px",
    },
  },
  brand: {
    width: "100px",
    height: "100px",
    "@media (max-width: 767px)": {
      width: "90px",
      height: "90px",
    },
  },
  card: {
    wrapper: {
      width: "100%",
    },
    horizontallyAlignedContainer: {
      margin: "0 auto",
      maxWidth: "680px",
      "@media (min-width: 769px)": {
        display: "flex",
      },
    },
    title: {
      color: "#fff",
      textAlign: "center",
      fontSize: "30px",
      textTransform: "uppercase",
      fontWeight: 700,
      fontFamily: '"Montserrat", "Montserrat"',
    },
    subTitle: {
      color: "#fff",
      textAlign: "center",
      fontSize: "24px",
      textTransform: "uppercase",
      fontWeight: 700,
      fontFamily: '"Montserrat", "Montserrat"',
      margin: "20px 0px 10px",
    },
    titleDimension1: {
      margin: "0 auto",
    },
    titleDimension2: {
      "@media (max-width: 767px)": {
        fontSize: "26px",
      },
      "@media (min-width: 769px)": {
        flexBasis: "20%",
        textAlign: "right",
      },
    },
    content: {
      color: "#fff",
      textAlign: "center",
      fontFamily: "Helvetica Neue",
      fontSize: "16px",
      lineHeight: "24px",
      marginBottom: "30px",
    },
    contentParagraph: {
      maxWidth: "700px",
      "@media (max-width: 1200px)": {
        maxWidth: "550px",
      },
      "@media (max-width: 787px)": {
        maxWidth: "none",
      },
    },
    margin: {
      margin: "50px 0 10px",
    },
    horizontallyAlignedContent: {
      marginBottom: 0,
      "@media (min-width: 769px)": {
        textAlign: "left",
        marginLeft: "10%",
        flexBasis: "80%",
      },
    },
    hr: {
      width: "60px",
      margin: "30px auto 50px",
      border: "none",
      height: "5px",
      color: "#0096FF",
      backgroundColor: "#0096FF",
      "@media (min-width: 769px)": {
        width: "50px",
        float: "right",
      },
    },
  },
  categoryIcon: {
    wrapper: {
      backgroundColor: "black",
      width: "25px",
      height: "25px",
    },
  },
  firstParagraph: {
    width: "80%",
    maxWidth: "680px",
    margin: "0 auto",
  },
  secondParagraph: {
    width: "100%",
  },
  sectionTitleWrapper: {
    fontSize: "30px",
    "@media (max-width: 768px)": {
      fontSize: "26px",
      padding: "0 30px",
    },
  },
  space100: {
    height: "100px",
  },
  testimonialsWrapper: {
    width: "70%",
    maxWidth: "900px",
    margin: "50px auto 0",
    padding: "0 76px",
    "@media (max-width: 767px)": {
      width: "100%",
      padding: "0 30px",
    },
  },
  space30: {
    height: "30px",
  },
};

export default styles;
